// Simple Collection Navigation Slider
function initCollectionNavigationSlider() {
  const slider = document.querySelector('.collection-navigation-swiper');
  if (!slider) {
    return;
  }

  const scrollbar = slider.querySelector('.collection-navigation-scrollbar');
  const slides = slider.querySelectorAll('.swiper-slide');
  
  if (slides.length === 0) {
    return;
  }
  
  if (typeof Swiper === 'undefined') {
    return;
  }
  
  try {
    const swiper = new Swiper(slider, {
      loop: false,
      slidesPerView: 2.1,
      spaceBetween: 16,
      breakpoints: {
        750: {
          slidesPerView: 3.2,
          spaceBetween: 20
        },
        990: {
          slidesPerView: 4.2,
          spaceBetween: 30
        }
      },
      watchOverflow: true,
      observer: true,
      observeParents: true,
      scrollbar: {
        el: scrollbar,
        draggable: true,
        dragSize: 100,
        draggableTrack: true,
        draggableTrackClickable: true,
        hide: false,
        snapOnRelease: true
      },
      on: {
        init: function() {
          updateScrollbarVisibility(this);
        },
        resize: function() {
          updateScrollbarVisibility(this);
        }
      }
    });
    
    // Function to update scrollbar visibility
    function updateScrollbarVisibility(swiperInstance) {
      setTimeout(() => {
        const scrollbar = slider.querySelector('.swiper-scrollbar');
        if (scrollbar) {
          // Check if scrollbar should be visible
          const isScrollable = !swiperInstance.isEnd || !swiperInstance.isBeginning;
          const hasEnoughSlides = slides.length > 4;
          
          if (hasEnoughSlides || isScrollable) {
            scrollbar.style.display = 'block';
            scrollbar.style.visibility = 'visible';
            scrollbar.style.opacity = '1';
          } else {
            scrollbar.style.display = 'none';
          }
        }
      }, 300);
    }
    
    // Initial update
    updateScrollbarVisibility(swiper);
    
    return swiper;
  } catch (error) {
    console.error('Error initializing slider:', error);
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionNavigationSlider);
} else {
  initCollectionNavigationSlider();
}

// Also try after a delay
setTimeout(initCollectionNavigationSlider, 1000);

// Listen for Shopify section events
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.collection-navigation-swiper')) {
    setTimeout(() => initCollectionNavigationSlider(), 100);
  }
}); 